export default __webpack_public_path__ + "0e3f3acb47a9e1367d2a5f8df64f19ba.png";